/**
 * CUSTOMER-172B — optional non-PII HUD when ?search_perf=1
 */
import { useEffect, useState } from "react";
import {
  getFocusInputTraceSummary,
  isSearchPerfDiagEnabled,
} from "./search-focus-trace-v2.js";

export function SearchPerfDiagHud() {
  const [enabled] = useState(() => isSearchPerfDiagEnabled());
  const [snap, setSnap] = useState(() => getFocusInputTraceSummary());

  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => setSnap(getFocusInputTraceSummary()), 400);
    return () => clearInterval(id);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div
      className="sv2-search-perf-hud"
      data-testid="sv2-search-perf-hud"
      style={{
        position: "fixed",
        left: 8,
        bottom: 8,
        zIndex: 9999,
        fontSize: 11,
        lineHeight: 1.35,
        padding: "8px 10px",
        borderRadius: 8,
        background: "rgba(0,0,0,0.72)",
        color: "#fff",
        maxWidth: "92vw",
        pointerEvents: "none",
        fontFamily: "ui-monospace, monospace",
      }}
    >
      <div>focus→input: {snap.focus_to_input_ms?.toFixed?.(0) ?? "—"}ms</div>
      <div>1st key→paint: {snap.first_key_to_paint_ms?.toFixed?.(0) ?? "—"}ms</div>
      <div>
        longTasks: {snap.long_task_count} max={snap.max_long_task_ms.toFixed(0)}ms
      </div>
      <div>
        listeners: scroll=
        {(window as Window & { __AS_SEARCH_LISTENER_AUDIT__?: { scroll: number; touchmove: number } })
          .__AS_SEARCH_LISTENER_AUDIT__?.scroll ?? "—"}{" "}
        touch=
        {(window as Window & { __AS_SEARCH_LISTENER_AUDIT__?: { scroll: number; touchmove: number } })
          .__AS_SEARCH_LISTENER_AUDIT__?.touchmove ?? "—"}
      </div>
    </div>
  );
}
